export default () => ({
	increment() {
		this.step((input) => input.stepUp());
	},

	decrement() {
		this.step((input) => input.stepDown());
	},

	step(fn) {
		let input = this.$refs.input;
		let prev = input.value;

		fn(this.$refs.input);

		if (prev != input.value) {
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
	},

});
